export const transactionsDemoData = [
    {
        id: 1,
        userId: 1,
        invoiceId: 45,
        gateway: 'manual',
        paymentId: '0',
        method: 'manual',
        invoiceCustomNumber: 'INV-1001',
        cardType: '',
        bank: '',
        amount: 40788,
        currency: 'USD',
        timeInitiate: 0,
        timeSuccess: 0,
        timeFailed: 0,
        note: 'All Paid',
        status: 'paid',
        demo: true
    },
    {
        id: 2,
        userId: 1,
        invoiceId: 45,
        gateway: 'manual',
        invoiceCustomNumber: 'INV-1002',
        paymentId: '0',
        method: 'manual',
        cardType: '',
        bank: '',
        amount: 40788,
        currency: 'USD',
        timeInitiate: 0,
        timeSuccess: 0,
        timeFailed: 0,
        note: 'All Paid',
        status: 'paid',
        demo: true
    }
];

export default null;
